<script>
import { GlFormGroup, GlFormInput } from '@gitlab/ui';
import { ValidationProvider } from 'vee-validate';
import validationStateMixin from '~/javascripts/forms/validation/mixins/validation_state_mixin';

export default {
  name: 'InputField',
  components: {
    GlFormGroup,
    GlFormInput,
    ValidationProvider,
  },
  mixins: [validationStateMixin],
  props: {
    label: {
      type: String,
      required: true,
    },
    labelDescription: {
      type: String,
      required: false,
      default: '',
    },
    hideLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
    optional: {
      type: Boolean,
      required: false,
      default: false,
    },
    optionalText: {
      type: String,
      required: false,
      default: '(optional)',
    },
    customMessages: {
      type: Object,
      required: false,
      default: () => {},
    },
    testId: {
      type: String,
      required: true,
    },
    groupClass: {
      type: [String, Object, Array],
      required: false,
      default: '',
    },
    rules: {
      type: [String, Object],
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['input', 'blur'],
  computed: {
    groupLabel() {
      if (this.hideLabel) {
        return '';
      }

      return this.label;
    },
  },
};
</script>

<template>
  <validation-provider
    #default="validationContext"
    :name="label"
    :rules="rules"
    :custom-messages="customMessages"
    :disabled="disabled"
    slim
  >
    <gl-form-group
      :class="groupClass"
      :data-testid="testId"
      :label="groupLabel"
      :label-description="labelDescription"
      :optional="optional"
      :optional-text="optionalText"
      :label-for="$attrs.id"
      :invalid-feedback="validationContext.errors[0]"
      :state="getValidationState(validationContext)"
    >
      <template v-if="groupLabel && $scopedSlots['label-help']" #label>
        <span data-testid="label">{{ groupLabel }}</span>
        <slot name="label-help"></slot>
        <span v-if="optional" class="optional-label" data-testid="optional-label">{{
          optionalText
        }}</span>
        <div v-if="labelDescription" class="label-description" data-testid="label-description">
          {{ labelDescription }}
        </div>
      </template>
      <gl-form-input
        :id="$attrs.id"
        :data-testid="`${testId}-input`"
        :name="$attrs.name"
        :disabled="disabled"
        :state="getValidationState(validationContext)"
        v-bind="$attrs"
        v-on="$listeners"
      />
    </gl-form-group>
  </validation-provider>
</template>
